import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Grid, Paper } from '@material-ui/core'
import CustomCard from '../Components/CustomCard'
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart'
import PersonIcon from '@material-ui/icons/Person'
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom'
import Chart from '../Components/Chart'
import clsx from 'clsx'

const useStyle = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 300,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: '1.5rem',
  },
  pos: {
    marginBottom: 12,
  },
}))

export default function Dashboard(props) {
  const classes = useStyle()
  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight)
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6} md={4}>
        <CustomCard
          icon={
            <ShoppingCartIcon
              style={{ fontSize: '2.7rem' }}
              color='secondary'
            ></ShoppingCartIcon>
          }
          title={'Günlük Satış'}
        ></CustomCard>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <CustomCard
          icon={
            <PersonIcon
              style={{ fontSize: '2.7rem' }}
              color='secondary'
            ></PersonIcon>
          }
          title={'Online Oyuncu'}
        ></CustomCard>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <CustomCard
          icon={
            <MeetingRoomIcon
              style={{ fontSize: '2.7rem' }}
              color='secondary'
            ></MeetingRoomIcon>
          }
          title={'Açık Lobi'}
        ></CustomCard>
      </Grid>
      <Grid item xs={12}>
        <Paper className={fixedHeightPaper}>
          <Chart></Chart>
        </Paper>
      </Grid>
    </Grid>
  )
}
